/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Apis_List_EmptyInputs */



/**
* | output |
* | --- |
* | "No APIs approved yet, so the assistant cannot call any external API." |
*
* @param {Integrations_Apis_List_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_apis_list_empty = /** @type {((inputs?: Integrations_Apis_List_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Apis_List_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch keine APIs freigegeben – der Assistent kann keine externe API aufrufen.")
	return /** @type {LocalizedString} */ ("No APIs approved yet, so the assistant cannot call any external API.")
});